module.exports = __webpack_public_path__ + "2fc440610fcdf8ffbdb275e329a798e8.svg";